module.exports = __webpack_public_path__ + "img/1600_YR_2022_Background.986958bb.png";